export default {
  notFound: {
    empty: {
      action: {
        notes: 'Label for a button that navigates the user to /',
        message: 'Home',
      },
      text: {
        notes: 'Text that are displayed if a page is not found (404-error)',
        message: 'The page could not be found',
      },
    },
  },
};
